/**
 * SAQ+C tables have two "unit family" rows - intensity (bpm/RPE/%/W) and rest
 * per rep (secs/bpm). Each unit is its own primaryRowSwitch key, e.g.
 * 'intensity (%)', and exactly one key per family may be on.
 */
const UNIT_FAMILY_PREFIXES = ['intensity (', 'rest per rep ('];

const familyPrefix = (name) => UNIT_FAMILY_PREFIXES.find((prefix) => name.startsWith(prefix));

/** Turns `name` on and every other unit in its family off. Names outside a
 * family are just turned on. */
export const selectUnitInFamily = (switchState, name) => {
  const prefix = familyPrefix(name);
  const next = { ...switchState };
  if (prefix) {
    Object.keys(next).forEach((key) => {
      if (key.startsWith(prefix)) next[key] = false;
    });
  }
  next[name] = true;
  return next;
};

/** When the family is on, makes `key` its only checked unit. The row's name
 * is rebuilt from `content` on every update, so this keeps the checkmark in
 * step with the unit the row shows. Leaves a family that's off untouched. */
export const syncUnitFamily = (switchState, key) => {
  const prefix = familyPrefix(key);
  const familyIsOn = Object.keys(switchState).some(
    (name) => name.startsWith(prefix) && switchState[name],
  );
  return familyIsOn ? selectUnitInFamily(switchState, key) : switchState;
};

const isBlankValue = (value) => value === '' || (typeof value === 'number' && Number.isNaN(value));

/** The API takes null for a blank rest per rep or intensity value but rejects
 * '' ("Invalid rest per rep value"). A cleared cell is stored as '', so blank
 * those out before sending. Absent keys stay absent; a typed 0 is left for the
 * API to reject, since the coach entered it. */
export const nullBlankUnitValues = (sets) => sets.map((set) => {
  const next = { ...set };
  if (isBlankValue(next.restPerRep)) next.restPerRep = null;
  if (isBlankValue(next.intensityValue)) next.intensityValue = null;
  return next;
});
